import { render, staticRenderFns } from "./Separacion.vue?vue&type=template&id=f4cad38e&"
import script from "./Separacion.vue?vue&type=script&lang=js&"
export * from "./Separacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports